import styled from "styled-components";
import type { CalendarStyledProps } from "..";

export const CalendarStyled = styled.div<CalendarStyledProps>`
  justify-content: ${({ $horizontalAlignment }) => $horizontalAlignment};
  .iframe__wrapper {
    width: var(--entity-size);
    height: var(--entity-height);
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .placeholder,
  .empty,
  .iframe__wrapper {
    border-radius: ${({ $round }) => $round};
  }
`;
